var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-brand-primary",attrs:{"id":"DmhSliderQuestion"}},_vm._l((_vm.question.sliders),function(question,i){return _c('Slider',{attrs:{"question":question,"updateAnswer":_vm.updateAnswer,"index":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }